import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';
import {Link} from "react-router-dom";

import destinationApi from '../../api/destinationApi';
import { lang } from '../../config/lang';
import { Businesses } from '../../config/Helper';
import ExperienceBlock from './ExperienceBlock';

class Experience extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            arrExperience : []
        }
        this.business = Businesses.indexOf('destination');
        this.id = this.props.id;

        this.getExperience = this.getExperience.bind(this);
    }

    componentWillMount() { 

    }

    componentDidMount() {
        this.getExperience();
    }

    componentDidUpdate() {
        window.checkSize();
        window.playVideo();
    }
  
    componentWillUnmount() {
        
    }

    componentWillReceiveProps(newProps) {
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getExperience();
        }
        if (this.id !== newProps.id) {
            this.id = newProps.id;
            this.getExperience();
        }
    }   

    getExperience() {
        destinationApi.getDestinationExperience(this.props.business, this.id).then((json) => {
            if (json.status === 200 && json.data.total !== 0) {
                this.setState({
                    arrExperience : json.data.data
                })
            } else {
                if(json.status === 200 && json.data.total === 0) {
                    this.setState({
                        arrExperience : []
                    })
                }
            }            
        });
    }

    render() {
        if(this.state.arrExperience.length === 0) {
            return(
                <div></div>
            )
        }
        return (

            <div className="side-box">
                {
                    (this.props.placeExperienceTitle !== undefined || this.props.placeExperienceTitle !== null) &&
                    <h2 className="heading">{this.props.placeExperienceTitle}</h2>
                }
                {
                    (this.props.serviceExperienceTitle !== undefined || this.props.serviceExperienceTitle !== null) &&
                    <h2 className="heading">{this.props.serviceExperienceTitle}</h2>
                }
                
                <ul className="post-list list-unstyled">
                    {
                        this.state.arrExperience.map((experience, key) => (
                        <ExperienceBlock 
                            key         = {key}
                            business    = {this.props.business} 
                            id          = {experience.id} 
                            title       = {experience.title}
                            image       = {experience.media_filename} 
                            media_type  = {experience.media_filetype}
                        />
                        ))
                    }
                    <li>
                        <Link to={"/blog/" + Businesses.indexOf('experience')} className="btn btn-primary btn-outline-primary">{lang('view_all')}
                            <i className="ion-ios-arrow-forward"></i>
                        </Link>
                    </li>
                </ul>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(Experience);